import { ENV as ENV_CONFIG } from "@/constants/envConfig";
export const ENV = {
  dev: "dev",
  fat: "fat",
  stage: "stage",
  prod: "prod",
};
export const isProd = () => {
  return ENV_CONFIG === "prod";
};
export const isClient = () => {
  return typeof Window !== "undefined";
};
